import Localization from '../../localization/LocalizationManager'

export enum CommonDateFilterMode {
  DAY = 'Day',
  WEEK = 'Week',
  THREE_WEEKS = 'Three Weeks',
  MONTH = 'Month',
  SIX_WEEKS = 'Six Weeks',
  THREE_MONTHS = '3 Months',
  YEAR = 'Year',
  PROJECT = 'Project',
}

export function getCommonDateFilterModeDisplayName(
  mode: CommonDateFilterMode,
): string {
  switch (mode) {
    case CommonDateFilterMode.DAY:
      return Localization.translator.day
    case CommonDateFilterMode.WEEK:
      return Localization.translator.week
    case CommonDateFilterMode.THREE_WEEKS:
      return Localization.translator.threeWeeks
    case CommonDateFilterMode.MONTH:
      return Localization.translator.month
    case CommonDateFilterMode.SIX_WEEKS:
      return Localization.translator.sixWeeks
    case CommonDateFilterMode.THREE_MONTHS:
      return Localization.translator.threeMonth
    case CommonDateFilterMode.YEAR:
      return Localization.translator.year
    case CommonDateFilterMode.PROJECT:
      return Localization.translator.project
    default:
      return mode
  }
}

export const MOVEMENT_DAYS: Record<CommonDateFilterMode, number> = {
  [CommonDateFilterMode.DAY]: 1,
  [CommonDateFilterMode.WEEK]: 7,
  [CommonDateFilterMode.THREE_WEEKS]: 7,
  [CommonDateFilterMode.MONTH]: 30,
  [CommonDateFilterMode.SIX_WEEKS]: 7,
  [CommonDateFilterMode.THREE_MONTHS]: 30,
  [CommonDateFilterMode.YEAR]: 365,
  [CommonDateFilterMode.PROJECT]: 0,
}

export const ALL_DATE_FILTER_MODES = [
  CommonDateFilterMode.DAY,
  CommonDateFilterMode.WEEK,
  CommonDateFilterMode.THREE_WEEKS,
  CommonDateFilterMode.MONTH,
  CommonDateFilterMode.SIX_WEEKS,
  CommonDateFilterMode.THREE_MONTHS,
  CommonDateFilterMode.YEAR,
  CommonDateFilterMode.PROJECT,
]

type DatePeriodType = 'day' | 'week' | 'month' | 'year' | 'project'

interface IDateModeConfig {
  periodType: DatePeriodType
  periodCount: number
  isDateFilterActive: boolean
}

export const MODE_CONFIG: Record<CommonDateFilterMode, IDateModeConfig> = {
  [CommonDateFilterMode.DAY]: {
    periodType: 'day',
    periodCount: 1,
    isDateFilterActive: true,
  },
  [CommonDateFilterMode.WEEK]: {
    periodType: 'week',
    periodCount: 1,
    isDateFilterActive: true,
  },
  [CommonDateFilterMode.THREE_WEEKS]: {
    periodType: 'week',
    periodCount: 3,
    isDateFilterActive: true,
  },
  [CommonDateFilterMode.SIX_WEEKS]: {
    periodType: 'week',
    periodCount: 6,
    isDateFilterActive: true,
  },
  [CommonDateFilterMode.MONTH]: {
    periodType: 'month',
    periodCount: 1,
    isDateFilterActive: true,
  },
  [CommonDateFilterMode.THREE_MONTHS]: {
    periodType: 'month',
    periodCount: 3,
    isDateFilterActive: true,
  },
  [CommonDateFilterMode.YEAR]: {
    periodType: 'year',
    periodCount: 1,
    isDateFilterActive: true,
  },
  [CommonDateFilterMode.PROJECT]: {
    periodType: 'project',
    periodCount: 1,
    isDateFilterActive: false,
  },
}
